import { render, staticRenderFns } from "./AppContentQuestionList.vue?vue&type=template&id=484b3b54&scoped=true&"
import script from "./AppContentQuestionList.vue?vue&type=script&lang=js&"
export * from "./AppContentQuestionList.vue?vue&type=script&lang=js&"
import style0 from "./AppContentQuestionList.vue?vue&type=style&index=0&id=484b3b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484b3b54",
  null
  
)

export default component.exports